import classNames from 'classnames'
import type { VFC } from 'react'

import { TENANT_IT } from 'shared/consts'
import { EXPERIMENT_VARIATION } from 'shared/experiments/consts'
import type { Tenant } from 'types/shopConfig'
import SearchProductLabel from 'views/components/organisms/FilteredProductList/SearchProductListItem/SearchProductLabel'

type TopDealLabelProps = Pick<RenderTopDealLabelProps, 'variant' | 'firstFound'>

export const TopDealLabel: VFC<TopDealLabelProps> = ({ variant }) => (
  <SearchProductLabel
    label="Top Deal"
    color={variant === EXPERIMENT_VARIATION.V1 ? 'dark' : 'white'}
    bgcolor={variant === EXPERIMENT_VARIATION.V1 ? 'warning' : 'red'}
    bordercolor={variant === EXPERIMENT_VARIATION.V1 ? 'warning' : 'red'}
    firstFound={false}
  />
)

type RenderTopDealLabelProps = {
  variant: `${EXPERIMENT_VARIATION}`
  tenant: Tenant
  className: string
  firstFound: boolean
}

export const RenderTopDealLabel: VFC<RenderTopDealLabelProps> = ({
  tenant,
  variant,
  className,
  firstFound,
}) => {
  const topDealClassNames = classNames(className, {
    'topDealV1': tenant === TENANT_IT && variant === EXPERIMENT_VARIATION.V1,
    'topDealV2': tenant === TENANT_IT && variant === EXPERIMENT_VARIATION.V2,
  })
  return (
    <div className="u-position--relative">
      <div className={topDealClassNames}>
        <TopDealLabel variant={variant} firstFound={firstFound} />
      </div>
    </div>
  )
}
